// src/dataTypes/broadcastingManagment/utils.ts

import { BaseBroadcastingChannel, TaggedEnrichedBroadcastedMedia } from './types'

import { Product } from '../productManagment/types'

import { getProductFromArray } from '../productManagment/utils'

// Tags retenus à l'écran — cf. enrichBroadcastedMediasWithTags (BroadcastingChannelSheet.tsx) :
// un tag "" signifie un statut backend non mappé, jamais retenu ici.
const RETAINED_BROADCASTED_MEDIA_TAGS = new Set(['to archive', 'queued', 'current', 'missed', 'not found']);

// Fusionne l'état local courant (prevTagged, potentiellement enrichi entre-temps
// par un ajout utilisateur pendant qu'un fetch était en vol) avec les données
// serveur fraîchement récupérées (serverTagged, déjà enrichies par
// enrichBroadcastedMediasWithTags) :
// - un item id===0 (pas encore sauvegardé côté serveur) est TOUJOURS préservé ;
// - un item connu des deux côtés est remplacé par sa version serveur (source de
//   vérité), sauf si son tag serveur n'est pas dans la liste de rétention ;
// - un item connu du serveur mais absent localement est ajouté (créé ailleurs,
//   ou jamais vu depuis le montage) ;
// - un item local connu qui n'existe plus côté serveur est abandonné.
// Fonction pure, sans dépendance React — testable directement en Jest.
export const mergeBroadcastedMediasPreservingLocal = (
  prevTagged: TaggedEnrichedBroadcastedMedia[],
  serverTagged: TaggedEnrichedBroadcastedMedia[]
): TaggedEnrichedBroadcastedMedia[] => {

  const serverById = new Map(serverTagged.map(m => [m.id, m]));
  const seenServerIds = new Set<number>();
  const merged: TaggedEnrichedBroadcastedMedia[] = [];

  for (const local of prevTagged) {
    if (local.id === 0) {
      merged.push(local);
      continue;
    }
    const serverVersion = serverById.get(local.id);
    if (!serverVersion) continue;
    seenServerIds.add(local.id);
    if (RETAINED_BROADCASTED_MEDIA_TAGS.has(serverVersion.tag)) merged.push(serverVersion);
  }

  for (const serverItem of serverTagged) {
    if (seenServerIds.has(serverItem.id)) continue;
    if (RETAINED_BROADCASTED_MEDIA_TAGS.has(serverItem.tag)) merged.push(serverItem);
  }

  return merged;
};

export const broadcastingChannelIsPaid = ( channel      : BaseBroadcastingChannel ,
                                           productArray : Product[]               ) : boolean => {
	

  let result = channel.associatedProductIds.length > 0


  for ( let p=0 ; p<channel.associatedProductIds.length; p++ )
   {
	const prod = getProductFromArray ( channel.associatedProductIds[p] , productArray )


	if ( prod && (prod as Product).active )
	      {
	       result = true;
	      }
	 else {
	       result = false
	      }
   }	  
   
   
  return result
}